import { OrderPaymentStatus, OrderStatus } from '@/enums/OrderEnums';
import { IOrder } from '@/interfaces/IOrder';
import { ITable } from '@/interfaces/ITable';
import { IPosTableView, TPosTableStatus } from '@/interfaces/IPosTableView';
import { orderMatchesSearch } from '@/utils/orders.utils';

/** Original PosV2TablesGrid projection: search filters orders before grouping. */
export function buildPosTableViews(
  tables: readonly ITable[] | null | undefined,
  seatOrders: readonly IOrder[],
  search: string
): IPosTableView[] | null {
  if (!tables) return null;
  const tableStatuses: TPosTableStatus[] = [
    'empty',
    'pending',
    'finished',
    'paid',
  ];
  let tableOrders = seatOrders;
  const q = search.trim();
  if (q)
    tableOrders = tableOrders.filter((order) => orderMatchesSearch(order, q));
  const ordersByTableId = tableOrders.reduce<Record<string, IOrder[]>>(
    (acc, order) => {
      if (!acc[order.tableId]) acc[order.tableId] = [];
      acc[order.tableId].push(order);
      return acc;
    },
    {}
  );
  const views: IPosTableView[] = [];
  tables.forEach((table) => {
    const orders = ordersByTableId[table.id] ?? [];
    if (!table.enabled && !orders.length) return;
    let total = 0;
    let tableStatusIndex: number = orders.length ? 3 : 0;
    const names: string[] = [];
    for (const order of orders) {
      total += order.total;
      if (order.userName) names.push(order.userName);
      if (tableStatusIndex > 1) {
        if (order.status !== OrderStatus.Finished) tableStatusIndex = 1;
        else if (order.paymentStatus !== OrderPaymentStatus.Paid)
          tableStatusIndex = 2;
      }
    }
    views.push({
      ...table,
      orders,
      total,
      tableStatus: tableStatuses[tableStatusIndex],
      names,
    });
  });
  return views;
}
